export const useSplashScreenStore = defineStore('splashScreen', () => {

  const splashScreen = ref<boolean>(true);

  const hideSplashScreen = () => {
    splashScreen.value = false;
  }

  return { splashScreen, hideSplashScreen }
})